import { createContext } from 'react';
import { Placement } from './streaming-creatives-constants';

export interface NonCartContextValue {
  viewPlacementId?: string;
  setViewPlacementId: (id?: string) => void;
  filteredPlacements: string[];
  setFilteredPlacements: (placements: Placement[]) => void;
}

export const NonCartContext = createContext<NonCartContextValue>({} as NonCartContextValue);
